import React from "react";
import { useTranslation } from "react-i18next";

export default function TotalPrize() {
  const { t } = useTranslation();
  return (
    <div className="overflow-hidden container mx-auto text-center font-soulmaze text-white py-80 bg-graphicPrize bg-no-repeat bg-cover bg-center  max-w-6xl">
      <h1 className="text-xl sm:text-2xl uppercase font-bold italic">
        {t("home.prize.title")}
      </h1>
      <div className="-rotate-6 mt-4">
        <h2 className="text-7xl sm:text-9xl uppercase font-bold italic pt-8">
          {t("home.prize.nominal")}
        </h2>
        <h2 className="text-3xl sm:text-4xl uppercase font-bold italic pt-12">
          {t("home.prize.desc")}
        </h2>
      </div>
    </div>
  );
}
